// Compound Product Videos (section-scoped)
// - Click the wrapper/thumbnail to play
// - Pauses any other playing video when a new one starts
// - Works with Shopify `deferred-media` markup used by `snippets/video.liquid`
(function () {
  const $$ = (sel, root) => Array.prototype.slice.call((root || document).querySelectorAll(sel));

  function isVideoEl(node) {
    return !!node && node.tagName === 'VIDEO';
  }

  function pauseAndResetItem(itemEl) {
    if (!itemEl) return;

    // Pause self-hosted video if present.
    const v = itemEl.querySelector('video');
    if (isVideoEl(v)) {
      try {
        v.pause();
        v.currentTime = 0;
      } catch (_) {}
    }

    // Stop iframe videos by clearing src (best-effort).
    const iframe = itemEl.querySelector('iframe');
    if (iframe) {
      const src = iframe.getAttribute('src') || '';
      if (src) {
        iframe.dataset.compoundSrc = src;
        iframe.setAttribute('src', '');
      }
    }

    const thumb = itemEl.querySelector('[data-video-thumbnail]');
    if (thumb) thumb.classList.remove('is-hidden');
    itemEl.classList.remove('is-playing');
  }

  function playItem(itemEl) {
    if (!itemEl) return;

    const thumb = itemEl.querySelector('[data-video-thumbnail]');
    if (thumb) thumb.classList.add('is-hidden');
    itemEl.classList.add('is-playing');

    // If a real <video> exists already (autoplay/no-preview cases), play it.
    const v = itemEl.querySelector('[data-video-element]') || itemEl.querySelector('video');
    if (isVideoEl(v)) {
      try {
        const p = v.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      } catch (_) {}
      return;
    }

    // Otherwise, trigger deferred-media play button if present.
    const deferred = itemEl.querySelector('deferred-media');
    const playBtn = deferred ? deferred.querySelector('.deferred-media__poster-button') : null;
    if (playBtn) {
      playBtn.click();
      // After it hydrates, a <video> may appear; try play again.
      window.setTimeout(() => {
        const vv = itemEl.querySelector('video');
        if (!isVideoEl(vv)) return;
        try {
          const p = vv.play();
          if (p && typeof p.catch === 'function') p.catch(() => {});
        } catch (_) {}
      }, 120);
    }
  }

  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.__compoundProductVideosInit) return;
    sectionEl.__compoundProductVideosInit = true;

    const items = $$('[data-video-item]', sectionEl);
    if (!items.length) return;

    const stopOthers = (activeItem) => {
      items.forEach((it) => {
        if (it !== activeItem) pauseAndResetItem(it);
      });
    };

    items.forEach((itemEl) => {
      const wrapper = itemEl.querySelector('.c-product-videos__video-wrapper');
      if (!wrapper) return;

      wrapper.addEventListener('click', (e) => {
        // If the item is already playing, we let the video controls handle play/pause
        // this prevents a "flash" or immediate re-play when clicking on the video
        if (itemEl.classList.contains('is-playing')) return;

        // If Shopify's own deferred-media button is clicked, let it run.
        if (e.target && e.target.closest && e.target.closest('.deferred-media__poster-button')) {
          stopOthers(itemEl);
          // Hide our custom thumbnail as well.
          const thumb = itemEl.querySelector('[data-video-thumbnail]');
          if (thumb) thumb.classList.add('is-hidden');
          itemEl.classList.add('is-playing');
          return;
        }

        stopOthers(itemEl);
        playItem(itemEl);
      });
    });

    // When a video starts playing (native controls), pause others.
    sectionEl.addEventListener(
      'play',
      (e) => {
        const target = e && e.target;
        if (!isVideoEl(target)) return;
        const itemEl = target.closest && target.closest('[data-video-item]');
        if (!itemEl) return;
        stopOthers(itemEl);
        const thumb = itemEl.querySelector('[data-video-thumbnail]');
        if (thumb) thumb.classList.add('is-hidden');
        itemEl.classList.add('is-playing');
      },
      true
    );
  }

  function init(root) {
    const scope = root || document;
    $$('[data-product-videos]', scope).forEach((el) => initSection(el));
  }

  // Expose for theme-editor / async loads.
  window.CompoundProductVideosInit = init;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (e) => init(e && e.target));
})();

